/* Early Access countdown (owner 2026-10-29): counts down to the next midnight US Eastern and starts again
 * every day, the same for every visitor. window.BF_END (snippets/bf-head.liquid) still switches the whole
 * sale off for good. */
(function () {
  var END = window.BF_END;
  if (!END) return;
  var pad = function (n) { return n < 10 ? '0' + n : String(n); };
  var DAY = 86400;
  var etClock = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });

  function secondsToEtMidnight() {
    var p = {};
    etClock.formatToParts(new Date()).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
    var into = (p.hour % 24) * 3600 + p.minute * 60 + p.second;
    return DAY - into;
  }

  function tick() {
    if (END - Date.now() <= 0) {
      document.documentElement.classList.remove('bf-live');
      return false;
    }
    var s = Math.min(secondsToEtMidnight(), Math.floor((END - Date.now()) / 1000));
    var parts = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
    document.querySelectorAll('[data-bf-timer] [data-u]').forEach(function (el) {
      var v = parts[el.getAttribute('data-u')];
      el.textContent = el.getAttribute('data-u') === 'd' ? String(v) : pad(v);
    });
    return true;
  }

  if (tick()) {
    var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
  }
})();

/* Premium buttons sold through the Shopify checkout (owner 2026-10-24: Shop Pay for VIP).
 * <a data-vip-variant="ID" [data-vip-plan="SELLING_PLAN_ID"] href="fallback">: add one VIP line with the
 * documented POST /cart/add.js (keeps the rest of the cart), skip if it is already there, then /checkout.
 * Any error falls back to the link's own href. */
(function () {
  function go(variant, plan) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var has = items.some(function (i) { return String(i.variant_id) === variant; });
        // Premium includes every printable: take the other lines out so nobody pays twice.
        var updates = {};
        items.forEach(function (i) { if (String(i.variant_id) !== variant) updates[i.key] = 0; });   // value lines re-added below
        var clear = Object.keys(updates).length
          ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
          : Promise.resolve();
        if (has && !Object.keys(updates).length) return clear;
        if (has) return clear.then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: 67814305497333, quantity: 1 }].concat(variant === '67813991612661' ? [{ id: 67814305628405, quantity: 1 }] : []) }) }); });
        return clear.then(function () {
          var item = { id: Number(variant), quantity: 1 };
          if (plan) item.selling_plan = Number(plan);
          // "Included with Premium" value lines (FREE via automatic discount): checkout shows the ladder
          var inc = [{ id: 67814305497333, quantity: 1 }];
          if (variant === '67813991612661') inc.unshift({ id: 67814305628405, quantity: 1 });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: inc.concat([item]) })
          }).then(function (r) { if (!r.ok) throw new Error('cart/add ' + r.status); });
        });
      })
      .then(function () { window.location.href = '/checkout'; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vip-variant]');
    if (!a) return;
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    go(a.getAttribute('data-vip-variant'), a.getAttribute('data-vip-plan')).catch(function () {
      window.location.href = a.href;
    });
  });
})();

/* /cart page: same rule as the drawer (Premium in the cart -> other lines removed). */
(function () {
  if (!document.body.classList.contains('template-cart')) return;
  var VIP = ['67813991612661', '67813991645429', '67813991678197'];
  var INC = ['67814305497333', '67814305595637', '67814305628405'];   // value lines stay with Premium
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
    var items = cart.items || [];
    var vip = items.some(function (i) { return VIP.indexOf(String(i.variant_id)) > -1; });
    var updates = {};
    if (vip) items.forEach(function (i) { var id = String(i.variant_id); if (VIP.indexOf(id) < 0 && INC.indexOf(id) < 0) updates[i.key] = 0; });
    if (!Object.keys(updates).length) return;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () { window.location.reload(); });
  });
})();
